module.exports = __webpack_public_path__ + "img/activity_head.5c35e377.png";